module.exports = __webpack_public_path__ + "f06e3a3930f25859ac07ab5d271615e3.svg";